import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, OnboardingFooter, OnboardingHeader, Text } from 'components';
import { appConfig } from 'config/app';
import Illustration from 'images/illustrations/not-found.svg';

export const AcceptInvitationConflict = () => {
  const history = useHistory();

  return (
    <>
      <OnboardingHeader title="Oops - Looks Like You Already Have An Employee Record At This Organization" />
      <img alt="Not Found Illustration" aria-hidden="true" src={Illustration} />
      <Text size="default">
        <span data-cy="messaging-conflict-error">
          {'Contact your manager and ask them to add this site to your existing employee record. If you need more assistance contact '}
          <Text as="a" href={appConfig.LINKS.SUPPORT} target="_blank" rel="noopener noreferrer">
            Kickfin Support
          </Text>
          .
        </span>
      </Text>

      <OnboardingFooter>
        <Button data-cy="action-btn" label="Use Kickfin" onClick={() => history.replace('/')} />
      </OnboardingFooter>
    </>
  );
};
